export const MENU = [
  {
    label: { ru: "СЕТЫ ВОЛКОВ", en: "WOLVES SETS", zh: "狼套餐" },
    links: [
      {
        label: {
          ru: "Орешки Микс (100г)",
          en: "Mixed Nuts(100)",
          zh: "混合坚果(100)",
        },
        description: {
          ru: "арахис, фисташка",
          en: "peanuts, pistachios",
          zh: "花生，开心果",
        },
        price: "15.00",
      },
      {
        label: {
          ru: "Микс Крыльев (600г)",
          en: "Wings Mix (600)",
          zh: "炸鸡翅拼盘 (600)",
        },
        description: {
          ru: "крылья BBQ, медово-горчичные, терияки, острые",
          en: "BBQ, honey mustard, teriyaki, hot wings",
          zh: "烧烤味，蜂蜜芥末味，照烧味，辣味鸡翅",
        },
        price: "40.00",
      },
      {
        label: {
          ru: "Grill Сет (950гр)",
          en: "Grill Set (950)",
          zh: "烧烤套餐 (950)",
        },
        description: {
          ru: "ребра, мякоть бедра, куриные колбаски, капуста, огурец, соуса",
          en: "ribs, thigh meat, chicken sausages, cabbage, cucumber, sauces",
          zh: "肋排，大腿肉，鸡肉肠，卷心菜，黄瓜，酱汁",
        },
        price: "65.00",
      },
      {
        label: {
          ru: "Сет под пиво (555гр)",
          en: "Beer Set (555)",
          zh: "啤酒套餐 (555)",
        },
        description: {
          ru: "картофель фри, дольки, наггетсы, сырные палочки, начос, соуса",
          en: "fries, potato wedges, nuggets, cheese sticks, nachos, sauces",
          zh: "薯条，薯角，鸡块，奶酪棒，玉米片，酱汁",
        },
        price: "35.00",
      },
    ],
  },
  {
    label: { ru: "СУП", en: "SOUP", zh: "汤" },
    links: [
      {
        label: {
          ru: "Грибной крем (300гр)",
          en: "Mushroom Cream Soup (300)",
          zh: "奶油蘑菇汤 (300)",
        },
        price: "12.00",
      },
      {
        label: {
          ru: "Солянка (350гр)",
          en: "Solyanka (350)",
          zh: "杂拌汤 (350)",
        },
        price: "13.00",
      },
      {
        label: {
          ru: "Холодник (330гр)",
          en: "Kholodnik (Cold Beet Soup) (330)",
          zh: "冷甜菜汤 (330)",
        },
        description: {
          ru: "на кефире с картофельными шариками",
          en: "on kefir with potato balls",
          zh: "基于酸奶和土豆球",
        },
        price: "10.00",
      },
    ],
  },
  {
    label: { ru: "САЛАТ", en: "SALAD", zh: "沙拉" },
    links: [
      {
        label: {
          ru: "Креветка Панко (220гр)",
          en: "Panko Shrimp (220)",
          zh: "天妇罗虾 (220)",
        },
        price: "19.00",
      },
      {
        label: {
          ru: "С наггетсами (200гр)",
          en: "With Nuggets (200)",
          zh: "鸡块沙拉 (200)",
        },
        price: "17.00",
      },
      {
        label: {
          ru: "С мякотью бедра Карри (230гр)",
          en: "With Curry Thigh Meat (230)",
          zh: "咖喱大腿肉沙拉 (230)",
        },
        price: "17.00",
      },
      {
        label: {
          ru: "Овощной (210гр)",
          en: "Vegetable Salad (210)",
          zh: "蔬菜沙拉 (210)",
        },
        price: "15.00",
      },
    ],
  },
  {
    label: { ru: "БУРГЕРЫ", en: "BURGERS", zh: "汉堡" },
    links: [
      {
        label: { ru: "Чизбургер 🌶️", en: "Cheeseburger 🌶️", zh: "芝士汉堡 🌶️" },
        price: "21.00",
      },
      {
        label: {
          ru: "Двойной чизбургер 🌶️",
          en: "Double Cheeseburger 🌶️",
          zh: "双层芝士汉堡 🌶️",
        },
        price: "31.00",
      },
      {
        label: {
          ru: "Чикенбургер с ананасом 🌶️",
          en: "Chicken Burger with Pineapple 🌶️",
          zh: "菠萝鸡肉堡 🌶️",
        },
        price: "19.00",
      },
      {
        label: {
          ru: "С рваной свининой и вишней",
          en: "Pulled Pork & Cherry Burger",
          zh: "手撕猪肉樱桃堡",
        },
        price: "20.00",
      },
      {
        label: {
          ru: "С креветкой панко",
          en: "With Panko Shrimp",
          zh: "天妇罗虾堡",
        },
        price: "21.00",
      },
      {
        label: {
          ru: "С мякотью бедра",
          en: "With Thigh Meat",
          zh: "大腿肉汉堡",
        },
        price: "20.00",
      },
    ],
  },
  {
    label: { ru: "ГРИЛЬ", en: "GRILL", zh: "烧烤" },
    links: [
      {
        label: {
          ru: "Ребра Свит Чили (350гр)",
          en: "Sweet Chili Ribs (350g)",
          zh: "甜辣酱排骨 (350克)",
        },
        price: "33.00",
      },
      {
        label: {
          ru: "Ребра медово-горчичные (450гр)",
          en: "Honey Mustard Ribs (450g)",
          zh: "蜂蜜芥末排骨 (450克)",
        },
        description: {
          ru: "с тушеной квашеной пикантной капустой",
          en: "with braised spicy sauerkraut",
          zh: "搭配炖辣酸菜",
        },
        price: "30.00",
      },
      {
        label: {
          ru: "Крылья в соусе терияки (250гр)",
          en: "Teriyaki Wings (250g)",
          zh: "照烧鸡翅 (250克)",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Крылья в медово-горчичном соусе (250гр)",
          en: "Honey Mustard Wings (250g)",
          zh: "蜂蜜芥末鸡翅 (250克)",
        },
        price: "18.00",
      },
      {
        label: { ru: "Крылья BBQ", en: "BBQ Wings", zh: "烧烤鸡翅" },
        price: "18.00",
      },
      {
        label: {
          ru: "Острые крылья 🌶️",
          en: "Hot Wings 🌶️",
          zh: "辣味鸡翅 🌶️",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Мякоть бедра (200/100/50гр)",
          en: "Thigh Meat (200/100/50g)",
          zh: "大腿肉 (200/100/50克)",
        },
        description: {
          ru: "в соусе Карри с картофельными шариками и соусом тар-тар",
          en: "in Curry sauce with potato balls and tartar sauce",
          zh: "咖喱酱搭配土豆球和塔塔酱",
        },
        price: "26.00",
      },
      {
        label: {
          ru: "Куриные колбаски (350гр)",
          en: "Chicken Sausages (350g)",
          zh: "鸡肉肠 (350克)",
        },
        description: {
          ru: "с картофелем фри и горчичным соусом",
          en: "with french fries and mustard sauce",
          zh: "搭配薯条和芥末酱",
        },
        price: "22.00",
      },
      {
        label: {
          ru: "Доннер со свининой (240гр)",
          en: "Pork Donner (240g)",
          zh: "猪肉多纳 (240克)",
        },
        description: {
          ru: "в соусе свит чили",
          en: "in sweet chili sauce",
          zh: "搭配甜辣酱",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Доннер с мякотью бедра (370гр)",
          en: "Chicken Thigh Donner (370g)",
          zh: "鸡大腿肉多纳 (370克)",
        },
        description: {
          ru: "",
          en: "",
          zh: "",
        },
        price: "17.00",
      },
      {
        label: {
          ru: "Лаваш с сыром и томатами (265гр)",
          en: "Lavash with cheese and tomatoes (265g)",
          zh: "奶酪番茄卷饼 (265克)",
        },
        price: "13.00",
      },
      {
        label: {
          ru: "Хот-Дог (300гр)",
          en: "Hot Dog (300g)",
          zh: "热狗 (300克)",
        },
        description: {
          ru: "с куриной колбаской, ананасом и кукурузой",
          en: "with chicken sausage, pineapple and corn",
          zh: "搭配鸡肉肠、菠萝和玉米",
        },
        price: "15.00",
      },
      {
        label: {
          ru: "Хот-Дог (225гр)",
          en: "Hot Dog (225g)",
          zh: "热狗 (225克)",
        },
        description: {
          ru: "с куриной колбаской и беконом",
          en: "with chicken sausage and bacon",
          zh: "搭配鸡肉肠和培根",
        },
        price: "15.00",
      },
    ],
  },
  {
    label: { ru: "ЗАКУСКИ", en: "SNACKS", zh: "小吃" },
    links: [
      {
        label: {
          ru: "Драники со сметаной (200гр)",
          en: "Potato pancakes with sour cream (200g)",
          zh: "土豆饼配酸奶油 (200克)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Драники (240гр)",
          en: "Potato pancakes (240g)",
          zh: "土豆饼 (240克)",
        },
        description: {
          ru: "с курицей, беконом и грибным соусом",
          en: "with chicken, bacon and mushroom sauce",
          zh: "搭配鸡肉、培根和蘑菇酱",
        },
        price: "17.00",
      },
      {
        label: {
          ru: "Драники (290гр)",
          en: "Potato pancakes (290g)",
          zh: "土豆饼 (290克)",
        },
        description: {
          ru: "со свининой и соусом свит чили",
          en: "with pork and sweet chili sauce",
          zh: "搭配猪肉和甜辣酱",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Креветки панко (250гр)",
          en: "Panko shrimp (250g)",
          zh: "天妇罗炸虾 (250克)",
        },
        price: "29.00",
      },
      {
        label: {
          ru: "Гренки (210гр)",
          en: "Croutons (210g)",
          zh: "面包干 (210克)",
        },
        description: {
          ru: "чесночные в сырном соусе",
          en: "garlic with cheese sauce",
          zh: "蒜香配奶酪酱",
        },
        price: "13.00",
      },
      {
        label: {
          ru: "Гренки чесночные (200гр)",
          en: "Garlic croutons (200g)",
          zh: "蒜香面包干 (200克)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Сырные палочки (150гр)",
          en: "Cheese sticks (150g)",
          zh: "奶酪棒 (150克)",
        },
        price: "14.00",
      },
      {
        label: {
          ru: "Картофель Фри (150гр)",
          en: "French fries (150g)",
          zh: "薯条 (150克)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Картофель по-деревенски (150гр)",
          en: "Potato wedges (150g)",
          zh: "美式薯角 (150克)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Картофельные шарики (150гр)",
          en: "Potato balls (150g)",
          zh: "土豆球 (150克)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Наггетсы (150гр)",
          en: "Nuggets (150g)",
          zh: "鸡块 (150克)",
        },
        price: "14.00",
      },
      {
        label: {
          ru: "Соус в ассортименте (50гр)",
          en: "Assorted sauces (50g)",
          zh: "各式酱料 (50克)",
        },
        price: "3.50",
      },
    ],
  },
  {
    label: { ru: "ДЕСЕРТ", en: "DESSERT", zh: "甜点" },
    links: [
      {
        label: {
          ru: "Брауни (110гр)",
          en: "Brownie (110g)",
          zh: "布朗尼 (110克)",
        },
        price: "17.00",
      },
      {
        label: { ru: "Чизкейк", en: "Cheesecake", zh: "芝士蛋糕" },
        price: "13.00",
      },
      {
        label: { ru: "Мороженое", en: "Ice Cream", zh: "冰淇淋" },
        price: "4.00",
      },
    ],
  },
  {
    label: {
      ru: "НАПИТКИ",
      en: "DRINKS",
      zh: "饮料",
    },
    links: [
      {
        label: {
          ru: "Coca-Cola (330мл)",
          en: "Coca-Cola (330ml)",
          zh: "可口可乐 (330毫升)",
        },
        price: "5.00",
      },
      {
        label: {
          ru: "Fanta (330мл)",
          en: "Fanta (330ml)",
          zh: "芬达 (330毫升)",
        },
        price: "5.00",
      },
      {
        label: {
          ru: "Sprite (330мл)",
          en: "Sprite (330ml)",
          zh: "雪碧 (330毫升)",
        },
        price: "5.00",
      },
      {
        label: {
          ru: "Bonaqua (500мл)",
          en: "Bonaqua (500ml)",
          zh: "Bonaqua 矿泉水 (500毫升)",
        },
        price: "4.00",
      },
      {
        label: {
          ru: "Gorilla (500мл)",
          en: "Gorilla Energy Drink (500ml)",
          zh: "Gorilla 能量饮料 (500毫升)",
        },
        price: "8.00",
      },
      {
        label: {
          ru: "Сок Villa Dini в ассортименте (200мл)",
          en: "Villa Dini Juice assorted (200ml)",
          zh: "Villa Dini 各种口味果汁 (200毫升)",
        },
        price: "3.00",
      },
    ],
  },
  {
    label: {
      ru: "КОФЕ",
      en: "COFFEE",
      zh: "咖啡",
    },
    links: [
      {
        label: {
          ru: "Эспрессо (30мл)",
          en: "Espresso (30ml)",
          zh: "浓缩咖啡 (30毫升)",
        },
        price: "5.00",
      },
      {
        label: {
          ru: "Американо (170мл)",
          en: "Americano (170ml)",
          zh: "美式咖啡 (170毫升)",
        },
        price: "5.00",
      },
      {
        label: {
          ru: "Капучино (220мл)",
          en: "Cappuccino (220ml)",
          zh: "卡布奇诺 (220毫升)",
        },
        price: "6.00",
      },
      {
        label: {
          ru: "Латте (230мл)",
          en: "Latte (230ml)",
          zh: "拿铁 (230毫升)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Флет-Уайт (240мл)",
          en: "Flat White (240ml)",
          zh: "澳白咖啡 (240毫升)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Раф (250мл)",
          en: "Raf Coffee (250ml)",
          zh: "拉夫咖啡 (250毫升)",
        },
        price: "7.00",
      },
    ],
  },
  {
    label: {
      ru: "ЧАЙ",
      en: "TEA",
      zh: "茶",
    },
    links: [
      {
        label: {
          ru: "Молочный улун (500мл)",
          en: "Milk Oolong (500ml)",
          zh: "奶香乌龙 (500毫升)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Ассам (500мл)",
          en: "Assam Tea (500ml)",
          zh: "阿萨姆红茶 (500毫升)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Сенча (500мл)",
          en: "Sencha (500ml)",
          zh: "煎茶 (500毫升)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Фруктовый чай (500мл)",
          en: "Fruit Tea (500ml)",
          zh: "水果茶 (500毫升)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Гречишный чай (500мл)",
          en: "Buckwheat Tea (500ml)",
          zh: "苦荞茶 (500毫升)",
        },
        price: "7.00",
      },
      {
        label: {
          ru: "Имбирный чай (500мл)",
          en: "Ginger Tea (500ml)",
          zh: "姜茶 (500毫升)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Облепиховый чай (500мл)",
          en: "Sea Buckthorn Tea (500ml)",
          zh: "沙棘茶 (500毫升)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Ромашковый чай с клюквой и бузиной (500мл)",
          en: "Chamomile Tea with cranberry and elderberry (500ml)",
          zh: "洋甘菊蔓越莓接骨木花茶 (500毫升)",
        },
        price: "9.00",
      },
    ],
  },
  {
    label: {
      ru: "ГОРЯЧИЕ НАПИТКИ",
      en: "HOT DRINKS",
      zh: "热饮",
    },
    links: [
      {
        label: {
          ru: "Какао с маршмеллоу (210мл)",
          en: "Cocoa with marshmallows (210ml)",
          zh: "棉花糖可可 (210毫升)",
        },
        price: "8.00",
      },
      {
        label: {
          ru: "Горячий шоколад с маршмеллоу (120мл)",
          en: "Hot chocolate with marshmallows (120ml)",
          zh: "棉花糖热巧克力 (120毫升)",
        },
        price: "11.00",
      },
    ],
  },
];

export const BAR = [
  {
    label: { ru: "ПИВО", en: "BEER", zh: "啤酒" },
    subcategories: [
      {
        label: { ru: "РАЗЛИВНОЕ ПИВО", en: "DRAFT BEER", zh: "生啤酒" },
        links: [
          {
            label: {
              ru: "Речицкое Золотое 4,6% (500/330мл)",
              en: "Rechitskoe Gold 4.6% (500/330ml)",
              zh: "Rechitskoe 金啤 4.6% (500/330毫升)",
            },
            price: "7.00 / 5.00",
          },
          {
            label: {
              ru: "Речицкое Белое 4,75% (500/330мл)",
              en: "Rechitskoe White 4.75% (500/330ml)",
              zh: "Rechitskoe 白啤 4.75% (500/330毫升)",
            },
            price: "7.00 / 5.00",
          },
          {
            label: {
              ru: "Речицкое Черное 3,9% (500/330мл)",
              en: "Rechitskoe Black 3.9% (500/330ml)",
              zh: "Rechitskoe 黑啤 3.9% (500/330毫升)",
            },
            price: "7.00 / 5.00",
          },
          {
            label: {
              ru: "Старопрамен 5% (500/330мл)",
              en: "Staropramen 5% (500/330ml)",
              zh: "Staropramen 5% (500/330毫升)",
            },
            price: "8.00 / 6.00",
          },
          {
            label: {
              ru: "Крушовица светлая 4,2% (500/330мл)",
              en: "Krusovice Light 4.2% (500/330ml)",
              zh: "Krusovice 黄啤 4.2% (500/330毫升)",
            },
            price: "8.00 / 6.00",
          },
          {
            label: {
              ru: "Жигули Барное Бархатное 4,5% (500/330мл)",
              en: "Zhiguli Barnoe Velvet 4.5% (500/330ml)",
              zh: "Zhiguli Barnoe 丝绒 4.5% (500/330毫升)",
            },
            price: "9.00 / 7.00",
          },
          {
            label: {
              ru: "Эдельвейс пшеничное 4,9% (500/330мл)",
              en: "Edelweiss Wheat 4.9% (500/330ml)",
              zh: "Edelweiss 小麦啤酒 4.9% (500/330毫升)",
            },
            price: "10.00 / 8.00",
          },
          {
            label: {
              ru: "IPA 5,5% (400мл)",
              en: "IPA 5.5% (400ml)",
              zh: "IPA 5.5% (400毫升)",
            },
            price: "11.00",
          },
          {
            label: {
              ru: "WIT (белое пшеничное) 4,5% (400мл)",
              en: "WIT (white wheat) 4.5% (400ml)",
              zh: "WIT (白小麦啤酒) 4.5% (400毫升)",
            },
            price: "11.00",
          },
          {
            label: {
              ru: "Сидорова Коза 5,5% (400мл)",
              en: "Sidorova Koza Cider 5.5% (400ml)",
              zh: "Sidorova Koza 苹果酒 5.5% (400毫升)",
            },
            price: "11.00",
          },
          {
            label: {
              ru: "Гостевой кран",
              en: "Guest tap",
              zh: "客座酒头",
            },
            price: "9.00",
          },
        ],
      },
      {
        label: {
          ru: "БУТЫЛОЧНОЕ ВОЛКОВСКАЯ ПИВОВАРНЯ",
          en: "BOTTLED VOLKOVSKAYA BREWERY",
          zh: "瓶装沃科夫斯基啤酒",
        },
        links: [
          {
            label: {
              ru: "Шоколадный стаут 6,5% (450мл)",
              en: "Chocolate Stout 6.5% (450ml)",
              zh: "巧克力世涛 6.5% (450毫升)",
            },
            price: "12.00",
          },
          {
            label: {
              ru: "APA 5,5% (450мл)",
              en: "APA 5.5% (450ml)",
              zh: "美式淡色艾尔 5.5% (450毫升)",
            },
            price: "12.00",
          },
          {
            label: {
              ru: "Фермерский Эль 6,5% (450мл)",
              en: "Farmhouse Ale 6.5% (450ml)",
              zh: "农场艾尔 6.5% (450毫升)",
            },
            price: "12.00",
          },
          {
            label: {
              ru: "Вишневый Эль 6,2% (450мл)",
              en: "Cherry Ale 6.2% (450ml)",
              zh: "樱桃艾尔 6.2% (450毫升)",
            },
            price: "12.00",
          },
          {
            label: {
              ru: "Pils (лагер светлый) 5,2% (450мл)",
              en: "Pils (light lager) 5.2% (450ml)",
              zh: "皮尔森 (淡色拉格) 5.2% (450毫升)",
            },
            price: "14.00",
          },
        ],
      },
      {
        label: { ru: "БУТЫЛОЧНОЕ", en: "BOTTLED", zh: "瓶装啤酒" },
        links: [
          {
            label: {
              ru: "Крушовица черное 3,8% (450мл)",
              en: "Krusovice Black 3.8% (450ml)",
              zh: "Krusovice 黑啤 3.8% (450毫升)",
            },
            price: "9.00",
          },
          {
            label: {
              ru: "Крушовица б/а (330мл)",
              en: "Krusovice Non-alcoholic (330ml)",
              zh: "Krusovice 无酒精 (330毫升)",
            },
            price: "8.00",
          },
        ],
      },
      {
        label: {
          ru: "ЛИМИТИРОВАННАЯ СЕРИЯ",
          en: "LIMITED EDITION",
          zh: "限量系列",
        },
        links: [
          {
            label: {
              ru: "От Волковской пивоварни в ассортименте (450мл)",
              en: "From Volkovskaya brewery assorted (450ml)",
              zh: "Volkovskaya 酿酒厂各种系列 (450毫升)",
            },
            price: "18.00",
          },
        ],
      },
      {
        label: {
          ru: "ПИВНОЙ БЕЗЛИМИТ",
          en: "UNLIMITED BEER",
          zh: "无限畅饮啤酒",
        },
        description: {
          ru: "все дни кроме пятницы и субботы",
          en: "every day except Friday and Saturday",
          zh: "除周五和周六外每天",
        },
        links: [
          {
            label: { ru: "Стандарт", en: "Standard", zh: "标准" },
            price: "37.00",
          },
          { label: { ru: "Крафт", en: "Craft", zh: "精酿" }, price: "57.00" },
        ],
      },
    ],
  },
  {
    label: {
      ru: "НАСТОЙКИ WOLKI GRILL",
      en: "WOLKI GRILL INFUSIONS",
      zh: "WOLKI GRILL 泡制酒",
    },
    links: [
      {
        label: {
          ru: "Настойки в ассортименте (Клюква, Слива, Малина, Абрикос, Вишня, Клубника) (50мл)",
          en: "Assorted Infusions (Cranberry, Plum, Raspberry, Apricot, Cherry, Strawberry) (50ml)",
          zh: "各式泡制酒 (蔓越莓, 李子, 覆盆子, 杏子, 樱桃, 草莓) (50毫升)",
        },
        price: "5.00",
      },
      {
        label: {
          ru: "Сет из 5-ти разных настоек (50*5мл)",
          en: "Set of 5 different infusions (5*50ml)",
          zh: "5种不同泡制酒组合 (5*50毫升)",
        },
        price: "21.00",
      },
    ],
  },
  {
    label: { ru: "ВИСКИ", en: "WHISKEY", zh: "威士忌" },
    links: [
      {
        label: {
          ru: "William Lawson's (40мл)",
          en: "William Lawson's (40ml)",
          zh: "威廉劳森 (40毫升)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Jim Beam (40мл)",
          en: "Jim Beam (40ml)",
          zh: "占边 (40毫升)",
        },
        price: "12.00",
      },
      {
        label: {
          ru: "Jameson 'Black Barrel'(40мл)",
          en: "Jameson 'Black Barrel'(40ml)",
          zh: "尊美醇 (40毫升)",
        },
        price: "15.00",
      },
      {
        label: {
          ru: "J. Walker Red Label (40мл)",
          en: "J. Walker Red Label (40ml)",
          zh: "尊尼获加红方 (40毫升)",
        },
        price: "14.00",
      },
      {
        label: {
          ru: "Jack Daniels old 7 (40мл)",
          en: "Jack Daniels old 7 (40ml)",
          zh: "杰克丹尼 7号 (40毫升)",
        },
        price: "15.00",
      },
      {
        label: {
          ru: "Bell's (40мл)",
          en: "Bell's (40ml)",
          zh: "贝尔 (40毫升)",
        },
        price: "11.00",
      },
    ],
  },
  {
    label: { ru: "РОМ", en: "RUM", zh: "朗姆酒" },
    links: [
      {
        label: {
          ru: "Bacardi Carta Blanca (40мл)",
          en: "Bacardi Carta Blanca (40ml)",
          zh: "百加得白朗姆 (40毫升)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Captain Morgan Dark (40мл)",
          en: "Captain Morgan Dark (40ml)",
          zh: "摩根船长黑朗姆 (40毫升)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Captain Morgan White (40мл)",
          en: "Captain Morgan White (40ml)",
          zh: "摩根船长白朗姆 (40毫升)",
        },
        price: "11.00",
      },
    ],
  },
  {
    label: { ru: "ДЖИН", en: "GIN", zh: "金酒" },
    links: [
      {
        label: {
          ru: "Gordon's (40мл)",
          en: "Gordon's (40ml)",
          zh: "哥顿金酒 (40毫升)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Bicken's (40мл)",
          en: "Bicken's (40ml)",
          zh: "Bicken's 金酒 (40毫升)",
        },
        price: "11.00",
      },
    ],
  },
  {
    label: { ru: "БРЕНДИ", en: "BRANDY", zh: "白兰地" },
    links: [
      {
        label: {
          ru: "Араспел (40мл)",
          en: "Araspel (40ml)",
          zh: "Araspel (40毫升)",
        },
        price: "6.00",
      },
      {
        label: {
          ru: "Арарат Ани (40мл)",
          en: "Ararat Ani (40ml)",
          zh: "亚拉拉特 (40毫升)",
        },
        price: "13.00",
      },
      {
        label: {
          ru: "Torres (40мл)",
          en: "Torres (40ml)",
          zh: "桃乐丝 (40毫升)",
        },
        price: "13.00",
      },
    ],
  },
  {
    label: { ru: "ТЕКИЛА", en: "TEQUILA", zh: "龙舌兰" },
    links: [
      {
        label: {
          ru: "Rooster Rojo Blanco (50мл)",
          en: "Rooster Rojo Blanco (50ml)",
          zh: "Rooster Rojo 白龙舌兰 (50毫升)",
        },
        price: "15.00",
      },
      {
        label: {
          ru: "Rooster Rojo Repasado (50мл)",
          en: "Rooster Rojo Repasado (50ml)",
          zh: "Rooster Rojo 金龙舌兰 (50毫升)",
        },
        price: "15.00",
      },
    ],
  },
  {
    label: {
      ru: "ЛИКЕР / ВЕРМУТ",
      en: "LIQUEUR / VERMOUTH",
      zh: "利口酒 / 味美思",
    },
    links: [
      {
        label: {
          ru: "Becherovka (40мл)",
          en: "Becherovka (40ml)",
          zh: "冰爵利口酒 (40毫升)",
        },
        price: "11.00",
      },
      {
        label: {
          ru: "Cinzano Bianco (40мл)",
          en: "Cinzano Bianco (40ml)",
          zh: "仙山露 白味美思 (40毫升)",
        },
        price: "6.00",
      },
      {
        label: {
          ru: "Cinzano Rosso (40мл)",
          en: "Cinzano Rosso (40ml)",
          zh: "仙山露 红味美思 (40毫升)",
        },
        price: "6.00",
      },
    ],
  },
  {
    label: { ru: "ВИНО / ПОРТВЕЙН", en: "WINE / PORTO", zh: "葡萄酒 / 波特酒" },
    links: [
      {
        label: {
          ru: "Niepoort Ruby Porto (75мл)",
          en: "Niepoort Ruby Porto (75ml)",
          zh: "尼波特红波特酒 (75毫升)",
        },
        price: "16.00",
      },
    ],
  },
  {
    label: { ru: "ВИНА КРАСНЫЕ", en: "RED WINES", zh: "红葡萄酒" },
    links: [
      {
        label: {
          ru: "Costa Azul Shiraz (Испания, сухое) (125мл)",
          en: "Costa Azul Shiraz (Spain, dry) (125ml)",
          zh: "Costa Azul 西拉 (西班牙, 干红) (125毫升)",
        },
        price: "9.00",
      },
      {
        label: {
          ru: "Valloria Puglia Primitivo (Италия, сухое) (125мл)",
          en: "Valloria Puglia Primitivo (Italy, dry) (125ml)",
          zh: "Valloria 普里米蒂沃 (意大利, 干红) (125毫升)",
        },
        price: "10.00",
      },
    ],
  },
  {
    label: { ru: "БЕЛОЕ ВИНО", en: "WHITE WINE", zh: "白葡萄酒" },
    links: [
      {
        label: {
          ru: "Costa Azul Sauvignon Blanc (Испания, сухое) (125мл)",
          en: "Costa Azul Sauvignon Blanc (Spain, dry) (125ml)",
          zh: "Costa Azul 长相思 (西班牙, 干白) (125毫升)",
        },
        price: "8.00",
      },
      {
        label: {
          ru: "Vallaoria Pino Grigio (Италия, сухое) (125мл)",
          en: "Vallaoria Pino Grigio (Italy, dry) (125ml)",
          zh: "Vallaoria 灰皮诺 (意大利, 干白) (125毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Pavao Escolha Vinho Verde (Португалия, полусухое) (125мл)",
          en: "Pavao Escolha Vinho Verde (Portugal, semi-dry) (125ml)",
          zh: "Pavao Escolha 绿酒 (葡萄牙, 半干白) (125毫升)",
        },
        price: "13.00",
      },
    ],
  },
  {
    label: { ru: "РОЗОВОЕ ВИНО", en: "ROSE WINE", zh: "桃红葡萄酒" },
    links: [
      {
        label: {
          ru: "Costa Azul Grenache (Испания, сухое) (125мл)",
          en: "Costa Azul Grenache (Spain, dry) (125ml)",
          zh: "Costa Azul 歌海娜 (西班牙, 干粉) (125毫升)",
        },
        price: "8.00",
      },
      {
        label: {
          ru: "I Castelli Pino Grigio Rose (Италия, сухое) (125мл)",
          en: "I Castelli Pino Grigio Rose (Italy, dry) (125ml)",
          zh: "I Castelli 灰皮诺桃红 (意大利, 干粉) (125毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Pavao Escolha Verde Rosso (Португалия, полусухое) (125мл)",
          en: "Pavao Escolha Verde Rosso (Portugal, semi-dry) (125ml)",
          zh: "Pavao Escolha 绿红葡萄酒 (葡萄牙, 半干) (125毫升)",
        },
        price: "13.00",
      },
    ],
  },
  {
    label: { ru: "ИГРИСТОЕ ВИНО", en: "SPARKLING WINE", zh: "起泡酒" },
    links: [
      {
        label: {
          ru: "Bosca Anna Federica (Латвия, белое, пл/сух) (125мл)",
          en: "Bosca Anna Federica (Latvia, white, semi-dry) (125ml)",
          zh: "Bosca Anna Federica (拉脱维亚, 白, 半干) (125毫升)",
        },
        price: "9.00",
      },
      {
        label: {
          ru: "Kava Brut (Испания, белое) (750мл)",
          en: "Cava Brut (Spain, white) (750ml)",
          zh: "卡瓦天然起泡酒 (西班牙, 白) (750毫升)",
        },
        price: "73.00",
      },
    ],
  },
  {
    label: { ru: "ГОРЯЧИЕ КОКТЕЙЛИ", en: "HOT COCKTAILS", zh: "热鸡尾酒" },
    links: [
      {
        label: {
          ru: "Глинтвейн Красный / Белый (250мл)",
          en: "Mulled Wine Red / White (250ml)",
          zh: "热红酒 红 / 白 (250毫升)",
        },
        price: "9.00",
      },
    ],
  },
  {
    label: { ru: "КОКТЕЙЛИ", en: "COCKTAILS", zh: "鸡尾酒" },
    links: [
      {
        label: {
          ru: "Kalimotxo / Калимочо (260мл)",
          en: "Kalimotxo (260ml)",
          zh: "卡里莫乔 (260毫升)",
        },
        description: {
          ru: "вино красное, кока-кола, лайм",
          en: "red wine, coca-cola, lime",
          zh: "红葡萄酒，可口可乐，青柠",
        },
        price: "13.00",
      },
      {
        label: {
          ru: "Aperol Spritz / Апероль Шприц (200мл)",
          en: "Aperol Spritz (200ml)",
          zh: "阿佩罗气泡 (200毫升)",
        },
        description: {
          ru: "апероль, игристое, содовая, апельсин",
          en: "aperol, sparkling wine, soda, orange",
          zh: "阿佩罗，起泡酒，苏打水，橙子",
        },
        price: "21.00",
      },
      {
        label: {
          ru: "Bellini / Белини (170мл)",
          en: "Bellini (170ml)",
          zh: "贝里尼 (170毫升)",
        },
        description: {
          ru: "игристое, персиковое пюре",
          en: "sparkling wine, peach puree",
          zh: "起泡酒，桃子泥",
        },
        price: "20.00",
      },
      {
        label: {
          ru: "Cuba Libra / Куба Либре (190мл)",
          en: "Cuba Libre (190ml)",
          zh: "自由古巴 (190毫升)",
        },
        description: {
          ru: "ром, кока-кола, лайм",
          en: "rum, coca-cola, lime",
          zh: "朗姆酒，可口可乐，青柠",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Paloma / Палома (190мл)",
          en: "Paloma (190ml)",
          zh: "帕洛玛 (190毫升)",
        },
        description: {
          ru: "текила, сок грейпфрута",
          en: "tequila, grapefruit juice",
          zh: "龙舌兰，葡萄柚汁",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Rosso Tonic / Россо Тоник (200мл)",
          en: "Rosso Tonic (200ml)",
          zh: "红味美思汤力 (200毫升)",
        },
        description: {
          ru: "вермут, тоник, апельсин",
          en: "vermouth, tonic, orange",
          zh: "味美思，汤力水，橙子",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Cherry Martini / Чери Мартини (200мл)",
          en: "Cherry Martini (200ml)",
          zh: "樱桃马提尼 (200毫升)",
        },
        description: {
          ru: "вермут, джин, сок вишня",
          en: "vermouth, gin, cherry juice",
          zh: "味美思，金酒，樱桃汁",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Whisky & Pineapple / Ананасовый виски (125мл)",
          en: "Whisky & Pineapple (125ml)",
          zh: "菠萝威士忌 (125毫升)",
        },
        description: {
          ru: "виски, ананасовый сок, лимонный сок",
          en: "whisky, pineapple juice, lemon juice",
          zh: "威士忌，菠萝汁，柠檬汁",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Negroni / Негрони (100мл)",
          en: "Negroni (100ml)",
          zh: "尼格罗尼 (100毫升)",
        },
        description: {
          ru: "джин, кампари, вермут",
          en: "gin, campari, vermouth",
          zh: "金酒，金巴利，味美思",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Daiquiri / Дайкири (100мл)",
          en: "Daiquiri (100ml)",
          zh: "大吉利 (100毫升)",
        },
        description: {
          ru: "ром, лайм, лимонный сок",
          en: "rum, lime, lemon juice",
          zh: "朗姆酒，青柠，柠檬汁",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Summer nigth's dreams / Сон в летнюю ночь (140мл)",
          en: "Summer night's dreams (140ml)",
          zh: "仲夏夜之梦 (140毫升)",
        },
        price: "18.00",
      },
      {
        label: {
          ru: "Сангрия Белая / Красная (250мл)",
          en: "Sangria White / Red (250ml)",
          zh: "桑格利亚 白 / 红 (250毫升)",
        },
        price: "8.00",
      },
      {
        label: {
          ru: "Сангрия Белая / Красная (1000мл)",
          en: "Sangria White / Red (1000ml)",
          zh: "桑格利亚 白 / 红 (1000毫升)",
        },
        price: "29.00",
      },
    ],
  },
  {
    label: { ru: "ЗАМЕСЫ", en: "MIXES", zh: "混合饮品" },
    links: [
      {
        label: {
          ru: "Виски/Кола (250мл)",
          en: "Whisky/Cola (250ml)",
          zh: "威士忌/可乐 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Виски/Яблочный сок (250мл)",
          en: "Whisky/Apple juice (250ml)",
          zh: "威士忌/苹果汁 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Джин/Тоник (250мл)",
          en: "Gin/Tonic (250ml)",
          zh: "金汤力 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Ром/Кола (250мл)",
          en: "Rum/Cola (250ml)",
          zh: "朗姆/可乐 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Ром/Цитрусовый сок (250мл)",
          en: "Rum/Citrus juice (250ml)",
          zh: "朗姆/柑橘汁 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Водка/Тоник (250мл)",
          en: "Vodka/Tonic (250ml)",
          zh: "伏特加/汤力 (250毫升)",
        },
        price: "9.00",
      },
      {
        label: {
          ru: "Водка/Кола (250мл)",
          en: "Vodka/Cola (250ml)",
          zh: "伏特加/可乐 (250毫升)",
        },
        price: "9.00",
      },
      {
        label: {
          ru: "Водка/Сок (250мл)",
          en: "Vodka/Juice (250ml)",
          zh: "伏特加/果汁 (250毫升)",
        },
        price: "9.00",
      },
    ],
  },
  {
    label: { ru: "ЛИМОНАДЫ", en: "LEMONADES", zh: "柠檬汁" },
    links: [
      {
        label: {
          ru: "Тропический (250мл)",
          en: "Tropical (250ml)",
          zh: "热带 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Малина Мята (250мл)",
          en: "Raspberry Mint (250ml)",
          zh: "覆盆子薄荷 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Грейпфрут Манго (250мл)",
          en: "Grapefruit Mango (250ml)",
          zh: "葡萄柚芒果 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Маракуйя Алыча (250мл)",
          en: "Passion fruit Cherry Plum (250ml)",
          zh: "百香果樱桃李 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Грушевый Мохито (250мл)",
          en: "Pear Mojito (250ml)",
          zh: "梨味莫希托 (250毫升)",
        },
        price: "10.00",
      },
      {
        label: {
          ru: "Классический (1000мл)",
          en: "Classic (1000ml)",
          zh: "经典 (1000毫升)",
        },
        price: "20.00",
      },
    ],
  },
  {
    label: { ru: "НА ОСНОВЕ КОФЕ", en: "COFFEE BASED", zh: "咖啡基饮" },
    links: [
      {
        label: {
          ru: "Бамбл (250мл)",
          en: "Bumble Coffee (250ml)",
          zh: "大黄蜂咖啡 (250毫升)",
        },
        price: "9.00",
      },
      {
        label: {
          ru: "Эспрессо Тоник (250мл)",
          en: "Espresso Tonic (250ml)",
          zh: "浓缩汤力 (250毫升)",
        },
        price: "9.00",
      },
      {
        label: {
          ru: "Айс Латте (250мл)",
          en: "Iced Latte (250ml)",
          zh: "冰拿铁 (250毫升)",
        },
        price: "7.00",
      },
    ],
  },
];
export const HOOKA = [
  {
    label: {},
    background: "light-bg",
    links: [
      {
        label: { ru: "ПРЕМИУМ", en: "PREMIUM", zh: "優質的" },
        description: { ru: "табачный лист", en: "tobacco leaf", zh: "菸葉" },
        price: "45",
        photo: "",
      },
    ],
  },
];
